module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("alert" + _vm._s(_vm.msg))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c26eb2e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Alert/alert.vue
// module id = 6
// module chunks = 0